

module.exports = __webpack_require__.stylable.create(
    "suggestionheader1467359289",
    {"classes":{"root":"suggestionheader1467359289__root","inner":"suggestionheader1467359289__inner","divider":"suggestionheader1467359289__divider","title":"suggestionheader1467359289__title","showAllLink":"suggestionheader1467359289__showAllLink"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    /*! ../node_modules/@wix/search-box-v2/dist/src/components/SuggestionHeader/SuggestionHeader.st.css */ 623,
    null
);
